import React from 'react';
import PlatformSummary from '../components/PlatformSummary';
const PlatformOverview: React.FC = () => {
  return <div className="min-h-screen bg-gray-50 py-12" data-id="element-3246">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3247">
        <div className="text-center mb-12" data-id="element-3248">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-3249">
            Future of Work Navigator Platform Overview
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-3250">
            A unified ecosystem connecting students, universities, employers,
            and government agencies to streamline higher education and workforce
            development in the UAE.
          </p>
        </div>
        <PlatformSummary data-id="element-3251" />
        <div className="mt-12 text-center" data-id="element-3252">
          <a href="/" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700" data-id="element-3253">
            Return to Home
          </a>
        </div>
      </div>
    </div>;
};
export default PlatformOverview;